import { Clamp, ClampProps } from '../Clamp';

export type CardTextProps = ClampProps;

export const CardText = (props: CardTextProps) => (
  <Clamp textStyle="body-normal-medium" {...props} />
);
